import React, { Component } from 'react';
import './App.css';

class App extends Component {
    render() {

        return (
            <div className="App">

                <div>
                    <div className="container">
                        <div className="row">
                            <div id="heading" className="col-12"/>
                        </div>
                    </div>
                </div>
                <div className="nav-gradient-border"/>
                <div id="Loader"/>
                <div id="body">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div id="summary"/>
                                <div id="summaryerror"/>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div id="message"/>
                                <div id="timeout"/>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div id="accordionframe"/>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div id="information"/>
                            </div>
                        </div>
                    </div>
                </div>

                <footer id="footer"/>
            </div>
        );
    }
}

export default App;